export default function PageShell({ children, className = "" }) {
  return <div className={`page-shell min-w-0 ${className}`.trim()}>{children}</div>;
}
